import { useNavigate } from "react-router";

import { useListDataWithLoadMore } from "../../../hooks";
import { GET_HT_USERS } from "../../../graphql/queries";
import { parseHtPatients } from "../../../graphql/utils";
import {
  PatientsHtProps,
  PatientHtPage as Component,
} from "../../../components/pages/patientHt/PatientHtPage";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";

export const PatientHtPage = () => {
  const navigate = useNavigate();

  useCheckUserRole();

  const {
    data,
    variables: { keyword, order },
    handlers: { onSearchClick, onResetClick, onSortClick, onLoadMoreClick },
  } = useListDataWithLoadMore(
    GET_HT_USERS,
    "htUsers",
    "処方情報は全て表示されています",
  );

  if (!data?.htUsers) {
    return null;
  }

  const props: PatientsHtProps = {
    patients: parseHtPatients(data.htUsers),
    searchValue: keyword,
    order,
    onSearchClick,
    onResetClick,
    onSortClick,
    onRowClick: (patientId: string) => navigate(`/patient_ht/${patientId}`),
    onLoadMoreClick,
  };

  return <Component {...props} />;
};
